import {
  IField,
  IFormDocument,
  IList,
  IListColumnInternalList,
} from 'app/services/api5-service/api.interface';

import { DocHelper } from 'utils/dochelper';

import { IListCollapseUi } from '../list-table/model';

/**
 * Get list collapse msgs
 *
 * @param control
 * @param field
 * @param doc - doc instance
 */
export function getListCollapse(
  control: IList,
  field: IField,
  doc: IFormDocument,
): IListCollapseUi | undefined {
  return control.$collapsible === 'yes'
    ? {
        anchorMsg: DocHelper.getMessage(`list_${field.$name}_collapse`, doc),
        toggleMsg: DocHelper.getMessage('dismiss', doc),
        unfoldMsg: DocHelper.getMessage('unfold', doc),
      }
    : undefined;
}

/**
 * Get internal list collapse msgs
 *
 * @param column
 * @param doc
 */
export function getInternalListCollapse(
  column: IListColumnInternalList,
  doc: IFormDocument,
): IListCollapseUi | undefined {
  return column.$collapsible === 'yes'
    ? {
        anchorMsg: DocHelper.getMessage(`list_${column.$name}_collapse`, doc),
      }
    : undefined;
}
